import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import {
  FetchBatteryLogsParams,
  FetchBatteryLogsResponse,
} from './battery.types';

export const fetchBatteryLogsAPI = async ({
  companyId,
  params,
}: FetchBatteryLogsParams): Promise<
  AxiosResponse<FetchBatteryLogsResponse & ApiError>
> => {
  return instance
    .get<FetchBatteryLogsResponse>(`companies/${companyId}/devices/battery`, {
      params,
    })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
